import { AchievementsActions, AchievementsActionTypes, AchievementsServiceState } from './Achievements.types'

export const achievementsServiceInitialState: AchievementsServiceState = {
  allow: true,
  suppressionCount: 0
}

export const achievementsReducer = (
  prevState: AchievementsServiceState = achievementsServiceInitialState,
  action: AchievementsActions
): AchievementsServiceState => {
  switch (action.type) {
    case AchievementsActionTypes.SUPPRESS_ACHIEVEMENTS: {
      const suppressionCount = prevState.suppressionCount + 1
      return {
        ...prevState,
        suppressionCount,
        allow: suppressionCount === 0
      }
    }
    case AchievementsActionTypes.ALLOW_ACHIEVEMENTS: {
      if ((prevState.suppressionCount ?? 0) === 0) return prevState
      const suppressionCount = prevState.suppressionCount - 1
      return {
        ...prevState,
        suppressionCount,
        allow: suppressionCount === 0
      }
    }
    default:
      return prevState
  }
}
